import React from "react";

const SkeletonRow = () => (
  <div className="flex items-center gap-4 shrink-0 border bg-[#F6F8F9] p-4 rounded-2xl border-solid border-[#DDE2E4] max767:w-full max767:mb-4 justify-between">
    <div className="flex flex-col gap-2 w-full">
      <div className="claims-skeleton-shimmer h-5 w-20 rounded-[10px]" />
      <div className="claims-skeleton-shimmer h-6 w-40 rounded-md" />
      <div className="claims-skeleton-shimmer h-4 w-28 rounded" />
    </div>
    <div className="claims-skeleton-shimmer h-5 w-5 rounded-sm shrink-0" />
  </div>
);

const ClaimsSkeleton = ({ count = 3 }) => {
  return (
    <>
      <style>{`
        .claims-skeleton-shimmer {
          background: linear-gradient(
            90deg,
            #E6EBEE 0%,
            #F2F5F7 50%,
            #E6EBEE 100%
          );
          background-size: 200% 100%;
          animation: claimsSkeletonShimmer 1.4s ease-in-out infinite;
        }
        @keyframes claimsSkeletonShimmer {
          0%   { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        [dir="rtl"] .claims-skeleton-shimmer {
          animation-direction: reverse;
        }
        @media (prefers-reduced-motion: reduce) {
          .claims-skeleton-shimmer { animation: none; }
        }
      `}</style>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonRow key={i} />
      ))}
    </>
  );
};

export default ClaimsSkeleton;
